(function () {
  if (!document.body.classList.contains('template-product')) return;

  var USP_EMOJI_MAP = {
    '♡': '❤️',
    '☆': '⭐',
    '❀': '🌸'
  };

  var SELECTOR =
    '.product-info__block-item[data-block-type="text-usp"] .metafield-multi_line_text_field';

  function replaceUspIcons() {
    document.querySelectorAll(SELECTOR).forEach(function (element) {
      var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var original = node.nodeValue;
        var updated = original.replace(
          /(^|\n)(\s*)([♡☆❀])(?=\s)/g,
          function (match, prefix, whitespace, icon) {
            return prefix + whitespace + USP_EMOJI_MAP[icon];
          }
        );
        if (updated !== original) {
          node.nodeValue = updated;
        }
      }
    });
  }

  replaceUspIcons();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceUspIcons, { once: true });
  }

  document.addEventListener('shopify:section:load', replaceUspIcons);
})();
